import app from 'flarum/app';
import Component from 'flarum/Component';
import Button from 'flarum/components/Button';
import FieldList from '../fields/FieldList';
import DiscussionFormModal from '../modals/DiscussionFormModal';

/* global m */

export default class DiscussionSubmission extends Component {
    init() {
        super.init();

        this.form = this.props.form;
        this.discussion = this.props.discussion;
    }

    view() {
        const submissions = this.discussion.formulaireSubmissions(); // Use the relationship, that way we are certain all submissions in there are already for the correct user
        const submission = submissions ? submissions.find(submission => submission.form().id() === this.form.id()) : null;

        return m('div', [
            m('h3', this.form.title()),
            this.form.attribute('canSubmit') ? Button.component({
                onclick: () => {
                    app.modal.show(new DiscussionFormModal({
                        form: this.form,
                        discussion: this.discussion,
                    }));
                },
                className: 'Button Button--icon',
                icon: 'fas fa-pen',
                title: 'Edit', //TODO: translate
            }) : null,
            this.submissionView(submission),
        ]);
    }

    submissionView(submission) {
        if (!submission) {
            return m('p', 'No data yet'); //TODO: translate
        }

        const list = new FieldList({
            configs: this.form.template(),
            submission: submission.formData(),
        });

        return list.listView(true);
    }
}
